import { EMPTY_CUSTOMER_ENQUIRY_ENTITY } from "domain/entity/CustomerEnquiry/CustomerEnquiryEntity";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { CustomerEnquiryRepository } from "domain/repository/CustomerEnquiry/CustomerEnquiryRepo";
import _ from "lodash";
import { CustomerEnquirySearchCriteria, EMPTY_CUSTOMER_ENQUIRY_SEARCH_CRITERIA } from "presentation/constant/CustomerEnquiry/CustomerEnquirySearchCriteria";
import { CustomerTypeDroOpts } from "presentation/constant/DropDownOptions/Company/CustomerTypeDroOpts";
import { CustomerEnquiryModel } from "presentation/model/CustomerEnquiry/CustomerEnquiryModel";
import { DropdownProps } from "presentation/model/DropdownProps";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface CustomerEnquiryVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<CustomerEnquiryModel>> | ((value: SetStateAction<CustomerEnquiryModel>) => void),
    ],
    customerEnquiryRepo: CustomerEnquiryRepository,
    companyRepo: CompanyRepository,
}

export const CustomerEnquiryVM = ({ dispatch, customerEnquiryRepo, companyRepo }: CustomerEnquiryVMProps) => {
    const [customerEnquiryDispatch] = dispatch;


    // const onSearch = async() => {
    //     customerEnquiryDispatch(prevState => {
    //         return {
    //             ...prevState,
    //             currentRow: {...EMPTY_CUSTOMER_ENQUIRY_ENTITY},
    //             currentEditRow: {...EMPTY_CUSTOMER_ENQUIRY_ENTITY},
    //             isShowEditPanel: false,
    //             isAdd: false,
    //             isEdit: false,
    //             updatedRows: [],
    //             customerEnquiryList: [],
    //         }
    //     })
    //     customerEnquiryRepo.searchAllCustomerEnquiryList().then(data =>{
    //         if(data){
    //             customerEnquiryDispatch(prevState => {
    //                 return {
    //                     ...prevState,
    //                     customerEnquiryList: data,
    //                 }
    //             })
    //         }else{
    //             customerEnquiryDispatch(prevState => {
    //                 return {
    //                     ...prevState,
    //                     customerEnquiryList: [],
    //                 }
    //             })
    //         }
    //     })
    // }

    const onSearch = async (searchCriteria: CustomerEnquirySearchCriteria) => {
        customerEnquiryDispatch(prevState => {
            return {
                ...prevState,
                currentRow: { ...EMPTY_CUSTOMER_ENQUIRY_ENTITY },
                currentEditRow: { ...EMPTY_CUSTOMER_ENQUIRY_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                updatedRows: [],
            }
        })

        await customerEnquiryRepo.searchAllCustomerEnquiryList(searchCriteria).then(data => {
            if (data) {
                customerEnquiryDispatch(prevState => {
                    return {
                        ...prevState,
                        customerEnquiryList: data,
                        isAllowAutoSearch: false,
                    }
                })
            } else {
                customerEnquiryDispatch(prevState => {
                    return {
                        ...prevState,
                        customerEnquiryList: [],
                        isAllowAutoSearch: false,
                    }
                })
            }
        })
    }

    const onRemoveAllSearchCriteria = () => {
        customerEnquiryDispatch(prevState => {
            return {
                ...prevState, searchCriteria: { ...EMPTY_CUSTOMER_ENQUIRY_SEARCH_CRITERIA }
            }
        })
    }

    const onMultipleDropdownChange = (e: any, fieldName: string) => {
        customerEnquiryDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldName]: _.uniq(e?.map((item: DropdownProps) => item.value)),
                }
            }
        });
    };

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        customerEnquiryDispatch(prevState => {

            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onSearchDropdownChange = (e: any, fieldName: string) => {
        customerEnquiryDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldName]: e.value,
                }
            }
        });
    };

    const onSearchClick = async () => {
        customerEnquiryDispatch(prevState => {
            return {
                ...prevState,
                isShowSearchPanel: !prevState.isShowSearchPanel
            }
        });
    }

    const loadDropdownOption = async () => {

        await customerEnquiryRepo.searchCustomerCodeForCombobox().then(
            customerCodeList => {
                let customerCodeDropdownOptions = customerCodeList?.map((customerCode) => ({
                    dropdownLabel: customerCode,
                    tagLabel: customerCode,
                    value: customerCode,
                })) ?? []

                customerEnquiryDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        customerCodeDropdownOptions: customerCodeDropdownOptions,
                    }
                }))
            }
        )

        await companyRepo.getAllCompanyForCombobox().then(
            companyCodeList => {
                const companyCodeDropdownOptions = companyCodeList?.map((companyEty) => ({
                    dropdownLabel: companyEty.companyCode,
                    tagLabel: companyEty.companyCode,
                    value: companyEty.companyCode,
                })) ?? []

                customerEnquiryDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        companyCodeDropdownOptions: _.sortBy(companyCodeDropdownOptions, ["tagLabel"]),
                    }
                }))
            }
        )

        customerEnquiryDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                customerTypeDropdownOptions: CustomerTypeDroOpts().getCustomerTypeModel()
            }
        }))

    }

    return {
        onSearch: onSearch,
        onRemoveAllSearchCriteria: onRemoveAllSearchCriteria,
        onMultipleDropdownChange: onMultipleDropdownChange,
        onSearchClick: onSearchClick,
        loadDropdownOption: loadDropdownOption,
        onSearchDropdownChange: onSearchDropdownChange,
        onSearchFieldChange: onSearchFieldChange,
    }
}